import React, { Component } from "react"
import {
  Grid,
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Menu,
  MenuItem,
} from "@material-ui/core"
import { Link } from "gatsby"
import styled from "@emotion/styled"
import GridWrapper from "../../atoms/GridWrapper"
import RowGrid from "../../atoms/RowGrid"
import MobileHeaderMenu from "./MobileHeaderMenu"
import HText from "../../atoms/LinkText"
import { withStyles } from "@material-ui/core/styles"
import { Menu as MenuIcon, Clear } from "@material-ui/icons"
import { colors } from "../../constants"

const Text = styled(HText)(
  {
    fontFamily: "cursive",
    flexGrow: 1,
    color: colors.brand,
  },
  props => ({
    fontSize: props.fontSize,
    textAlign: props.textAlign,
    textDecoration: props.textDecoration,
    color: props.color,
    fontWeight: props.fontWeight,
  })
)

const styles = {
  root: {
    flexGrow: 1,
    background: "#fff",
    height: "54px",
  },
  menuButton: {
    color: "#6e4946",
  },
}

class MobileHeader extends Component {
  state = {
    open: false,
  }

  handleClick = () => {
    this.setState({ open: !this.state.open })
  }
  handleClose = () => {
    this.setState({ open: false })
  }
  render() {
    const { classes } = this.props
    const { open } = this.state
    return (
      <AppBar position="fixed" className={classes.root}>
        <Toolbar>
          <Grid container>
            <Grid
              item
              xs={6}
              style={{ marginTop: "auto", marginBottom: "auto" }}
            >
              <Text fontSize={"20px"} to={"/"}>
                Katahira Seminar
              </Text>
            </Grid>
            <Grid item xs={6} style={{ textAlign: "right" }}>
              <IconButton
                className={classes.menuButton}
                aria-label="Menu"
                onClick={this.handleClick}
              >
                {open ? <Clear /> : <MenuIcon />}
              </IconButton>
            </Grid>
          </Grid>
          <MobileHeaderMenu handleClose={this.handleClose} open={open} />
        </Toolbar>
      </AppBar>
    )
  }
}

export default withStyles(styles)(MobileHeader)
